/**
 * To generate code verifier and code challenge
 */
export class SecurityHelper {

  /**
   * To generate the code verifier
   * @returns - code verifier
   * ```
   * @example
   * generateCodeVerifier();
   * ```
   */
  public generateCodeVerifier(): string {
    const array = new Uint32Array(56 / 2);
    window.crypto.getRandomValues(array);
    return Array.from(array, this.dec2hex).join('');
  }

  /**
   * Convert decimal to hexadecimal
   * @param dec - decimal number
   * @returns - hexadecimal - 20
   *
   * ```
   * @example
   * dec2hex(32);
   * ```
   */
   private dec2hex(dec: number): string {
    return ('0' + dec.toString(16)).substr(-2);
  }

  /**
   * To generate the code challenge
   *
   * @param verifier - code verifier
   * @returns - base64 Encoded value - ftMwffFeP8uzj-D9BKFG
   *
   * ```
   * @example
   * generateCodeChallengeFromVerifier('dfd7fe9fff84d20091bd6c');
   * ```
   */
  public async generateCodeChallengeFromVerifier(verifier: string): Promise<string> {
    const hashed = await this.sha256(verifier);
    const base64encoded = this.base64urlencode(hashed);
    return base64encoded;
  }

  /**
   *
   * @param plain - Code verifier
   * @returns - Array Buffer
   * ```
   * @example
   * sha256('dfd7fe9fff84d20091bd6c');
   * ```
   */
  private sha256(plain: string) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest('SHA-256', data);
  }

  /**
   *
   * @param buffer - Array Buffer
   * @returns - base64 endcoded url
   * ```
   * @example
   * base64urlencode([]);
   * ```
   */
  private base64urlencode(buffer: any): string {
    let str = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      str += String.fromCharCode(bytes[i]);
    }
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
}
